<!--  -->
<template>
    <div class="scrollContent">
        <slot></slot>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.scrollContent{
    overflow-y: scroll;
    position: relative;
}
.scrollContent::-webkit-scrollbar {
        width:8px;
        background-color: #090F29;
        border-radius:8px;
    }

    /* 滚动槽 */
.scrollContent::-webkit-scrollbar-track {
    border-radius:6px;
    }

    /* 滚动条滑块 */
.scrollContent::-webkit-scrollbar-thumb {
    border-radius:6px;
    background:#00A2EC;
}
</style>